var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#7DC37D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1029_1432",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 37
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1029_1432)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16359 7.7002H26.8363C27.9163 7.7002 28.7999 8.58383 28.7999 9.66383V27.3366C28.7999 28.4166 27.9163 29.3002 26.8363 29.3002H9.16359C8.08359 29.3002 7.19995 28.4166 7.19995 27.3366V9.66383C7.19995 8.58383 8.08359 7.7002 9.16359 7.7002ZM11.6181 12.1184C11.3236 12.1184 11.1272 12.3147 11.1272 12.6093V17.5184C11.1272 17.8129 11.3236 18.0093 11.6181 18.0093H16.5272C16.8218 18.0093 17.0181 17.8129 17.0181 17.5184V12.6093C17.0181 12.3147 16.8218 12.1184 16.5272 12.1184H11.6181ZM22.909 25.3729C22.909 25.6675 22.7127 25.8638 22.4181 25.8638H11.6181C11.3236 25.8638 11.1272 25.6675 11.1272 25.3729V24.3911C11.1272 24.0966 11.3236 23.9002 11.6181 23.9002H22.4181C22.7127 23.9002 22.909 24.0966 22.909 24.3911V25.3729ZM24.3818 21.9366C24.6763 21.9366 24.8727 21.7402 24.8727 21.4456V20.4638C24.8727 20.1693 24.6763 19.9729 24.3818 19.9729H11.6181C11.3236 19.9729 11.1272 20.1693 11.1272 20.4638V21.4456C11.1272 21.7402 11.3236 21.9366 11.6181 21.9366H24.3818ZM24.8727 17.5184C24.8727 17.8129 24.6763 18.0093 24.3818 18.0093H19.4727C19.1781 18.0093 18.9818 17.8129 18.9818 17.5184V16.5366C18.9818 16.242 19.1781 16.0456 19.4727 16.0456H24.3818C24.6763 16.0456 24.8727 16.242 24.8727 16.5366V17.5184ZM24.3818 14.082C24.6763 14.082 24.8727 13.8857 24.8727 13.5911V12.6093C24.8727 12.3147 24.6763 12.1184 24.3818 12.1184H19.4727C19.1781 12.1184 18.9818 12.3147 18.9818 12.6093V13.5911C18.9818 13.8857 19.1781 14.082 19.4727 14.082H24.3818Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.6e32bd05.svg";
export { ForwardRef as ReactComponent };